export function getMyPageCardState({
    hasResult,
    questComplete,
    premiumRoute = null,
    premiumUnlocked = false,
}) {
    if (!hasResult) {
        return {
            state: 'empty',
            showPremiumCta: false,
            premiumRoute: null,
            premiumLabel: null,
        };
    }

    if (premiumUnlocked) {
        return {
            state: 'premium_unlocked',
            showPremiumCta: true,
            premiumRoute,
            premiumLabel: null,
        };
    }

    if (premiumRoute && !questComplete) {
        return {
            state: 'missing_prerequisite',
            showPremiumCta: false,
            premiumRoute,
            premiumLabel: null,
        };
    }

    if (premiumRoute && questComplete) {
        return {
            state: 'premium_available',
            showPremiumCta: true,
            premiumRoute,
            premiumLabel: null,
        };
    }

    return {
        state: 'ready',
        showPremiumCta: false,
        premiumRoute: null,
        premiumLabel: null,
    };
}
